var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Youtube = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.getCurrentTime();
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.getDuration();
  },

  /** Override to return rendition */
  getRendition: function () {
    return this.player.getPlaybackQuality();
  },

  /** Override to return title */
  getTitle: function () {
    if (this.player.getVideoData()) {
      return this.player.getVideoData().title;
    } else {
      return 'unknown';
    }
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this.player.getVideoUrl();
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return 'YOUTUBE API';
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'Youtube';
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player);

    // Enable playhead monitor
    this.monitorPlayhead(true, true);

    // Register listeners
    var context = this;
    this.player.addEventListener("onStateChange", this.stateChangeListener.bind(this))
    this.player.addEventListener("onError", this.errorListener.bind(this))
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    this.player.removeEventListener("onStateChange", this.stateChangeListener)
    this.player.removeEventListener("onError", this.errorListener)
  },

  stateChangeListener: function (event) {
    switch (event.data) {
      case YT.PlayerState.UNSTARTED:
        this.fireStart()
        break;
      case YT.PlayerState.ENDED:
        this.fireStop()
        break;
      case YT.PlayerState.PLAYING:
        this.fireJoin()
        this.fireSeekEnd()
        this.fireResume()
        break;
      case YT.PlayerState.PAUSED:
        this.firePause()
        break;
      case YT.PlayerState.BUFFERING:
        this.fireStart() // first buffer will trigger /start
        break;
    }
  },

  errorListener: function (event) {
    var error = {
      "2": "Invalid ID",
      "5": "HTML5 content error",
      "100": "Video not found",
      "101": "Not allowed to play by owner",
    };

    var code = event.data
    if (code === 150) {
      // Error 150 is the same as 101 as stated in the documentation
      code = 101
    }

    if (error[code] !== undefined) {
      context.errorListener(code, error[code])
    } else {
      context.errorListener(code, 'Unknown error')
    }
  }
})

module.exports = youbora.adapters.Youtube



//////////////////
// WEBPACK FOOTER
// ./src/adapter.js
// module id = 25
// module chunks = 0